$.widget("custom.ajaxheight", {
    options: {},
    _create: function () {
        $(document).trigger("wrapperoffset");
    }
});